<epc-brand-org-site
  (click)="logoClick()"
  [sites]="availableSites$ | async"
  [selectedSite]="currentSite$ | async"
  [multiSiteSupport]="multiSiteSupport$ | async"
  (selectSite)="onSelectSite($event)"
  [isMobile]="isMobile$ | async"
></epc-brand-org-site>
